import { useState, useCallback, useMemo, useEffect } from 'react';
import { downloadDocumentFromUrl } from '../../utils/helpers';
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { getUser } from '../../utils/api';
import Loader from '../Loader';
import Header from '../Header';
import { faCar, faEllipsis, faTrashCan, faArrowsTurnToDots, faPencil, faPlus, faCirclePlus, faFile, faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency, formatDateToMMDDYYYYWithTime, openDocumentInNewTab } from '../../utils/helpers';
import ShowMenuButton from '../ShowMenuButton';
import Error from '../Error';
import { useDataStore } from '../../Store';

const ViewUserModal = ({ show, onHide, user }) => {

    const selectedEntity = useDataStore((state) => state.selectedEntity);
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, [show]);

    const fetchData = async () => {
        if (show) {
            setLoading(true);
            setError(null);
            const data = user && await getUser(selectedEntity, user.Id);
            if (data) {
                setData(data);
            }
            else {
                setError('Failed to fetch business Partner');
            }
            setLoading(false);
        }
        else {
            setData([]);
            setError(null);
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>View User (Id={user?.Id})</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        {loading ? <Loader /> : error ? <Error /> : (
                            <>
                                <Header title={user?.Vin} description={"Review details and access for user " + user?.Id} />
                                <Row>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap', }}>ID</th>
                                                <th tyle={{ whiteSpace: 'nowrap', }}>ExternalId</th>
                                                <th style={{ whiteSpace: 'nowrap', }}>FirstName</th>
                                                <th style={{ whiteSpace: 'nowrap', }}>LastName</th>
                                                <th style={{ whiteSpace: 'nowrap', }}>Email</th>
                                                <th style={{ whiteSpace: 'nowrap', }}>Blocked</th>
                                                <th style={{ whiteSpace: 'nowrap', }}>Role</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[data]?.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.ExternalId}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.FirstName}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.LastName}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Email}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Blocked ? 'Yes' : 'No'}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Role}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Roles
                                        </div>

                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Id
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Name
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Description
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.UserRoles
                                                    ?.map((d, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Role?.Id}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Role?.Name}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Role?.Description}</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Entities and Dealers
                                        </div>

                                        {data?.UserRoles?.some(c => c.Role.Id === 3) ? 'All' : (
                                            <Table striped bordered hover responsive>
                                                <thead>
                                                    <tr>
                                                        <th style={{ whiteSpace: 'nowrap', }}>
                                                            Id
                                                        </th>
                                                        <th style={{ whiteSpace: 'nowrap', }}>
                                                            EntityId
                                                        </th>
                                                        <th style={{ whiteSpace: 'nowrap', }}>
                                                            Entity
                                                        </th>
                                                        <th style={{ whiteSpace: 'nowrap', }}>
                                                            DealerId
                                                        </th>
                                                        <th style={{ whiteSpace: 'nowrap', }}>
                                                            Dealer
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.UserEntityDealers
                                                        ?.map((d, idx) => (
                                                            <tr key={idx}>
                                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Entity?.Id}</td>
                                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Entity?.LegalName}</td>
                                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Dealer?.Id}</td>
                                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Dealer?.Name}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </Table>
                                        )}
                                    </div>
                                </Row>
                                <br /><br />
                            </>
                        )}
                    </div>
                </Modal.Body>

            </Modal >
        </>
    );
};

export default ViewUserModal;